import type { IPublicUser } from '@sravni/types/lib/auth';

import type { GlobalState } from '../index';

export const getUser = (state: GlobalState): IPublicUser | null => (state.user.loggedIn ? state.user.account : null);
export const getIsUserLogged = (state: GlobalState): boolean => state.user.loggedIn;
export const getFingerprint = (state: GlobalState) => state.user.fp;
